// Ticket 28: Gift Leaderboards Page
import React, { useState } from 'react';
import { ArrowLeft } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import TopGiftersList from '../components/TopGiftersList';
import MostLovedList from '../components/MostLovedList';
import SelfRankCard from '../components/SelfRankCard';

const GiftLeaderboardsPage = () => {
  const [tab, setTab] = useState('gifters');
  const [range, setRange] = useState('weekly');
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-950 via-purple-950/30 to-slate-950">
      <div className="mx-auto flex h-full max-w-3xl flex-col px-3 py-3">
        {/* Header */}
        <div className="mb-3 flex items-center justify-between">
          <div className="flex items-center gap-2">
            <button
              onClick={() => navigate(-1)}
              className="flex h-8 w-8 items-center justify-center rounded-full bg-slate-900/60 text-slate-300 hover:bg-slate-800 transition-colors"
            >
              <ArrowLeft className="w-4 h-4" />
            </button>
            <h1 className="text-lg font-playfair font-semibold text-slate-50">
              Gift Leaderboards
            </h1>
          </div>
          
          {/* Range Toggle */}
          <div className="flex gap-1 rounded-full bg-slate-800/80 border border-slate-700/50 p-1 text-[10px]">
            <button
              onClick={() => setRange('weekly')}
              className={`rounded-full px-2 py-0.5 transition-colors ${
                range === 'weekly'
                  ? 'bg-pink-600 text-white'
                  : 'text-slate-300 hover:bg-slate-700'
              }`}
            >
              Weekly
            </button>
            <button
              onClick={() => setRange('all')}
              className={`rounded-full px-2 py-0.5 transition-colors ${
                range === 'all'
                  ? 'bg-pink-600 text-white'
                  : 'text-slate-300 hover:bg-slate-700'
              }`}
            >
              All Time
            </button>
          </div>
        </div>

        {/* Self Rank Card */}
        <SelfRankCard range={range} />

        {/* Tab Switcher */}
        <div className="mt-3 mb-2 flex gap-1 rounded-full bg-slate-800/80 border border-slate-700/50 p-1 text-xs">
          <button
            onClick={() => setTab('gifters')}
            className={`flex-1 rounded-full px-3 py-1.5 font-semibold transition-colors ${
              tab === 'gifters'
                ? 'bg-pink-600 text-white'
                : 'text-slate-300 hover:bg-slate-800'
            }`}
          >
            🏆 Top Gifters
          </button>
          <button
            onClick={() => setTab('loved')}
            className={`flex-1 rounded-full px-3 py-1.5 font-semibold transition-colors ${
              tab === 'loved'
                ? 'bg-pink-600 text-white'
                : 'text-slate-300 hover:bg-slate-800'
            }`}
          >
            💖 Most Loved
          </button>
        </div>

        {/* Leaderboard List */}
        <div className="flex-1 overflow-y-auto pb-4">
          {tab === 'gifters' && <TopGiftersList range={range} />}
          {tab === 'loved' && <MostLovedList range={range} />}
        </div>
      </div>
    </div>
  );
};

export default GiftLeaderboardsPage;
